import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { base_url } from "../../../Base/base_Url";

export const FeedbackApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: `${base_url}` ,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token_Front_Mied");
      const language = localStorage.getItem('userLanguage') || "en"
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      headers.set("Accept-Language", language);

      return headers;
    },
}),
  reducerPath: "FeedbackApi",
  endpoints: (build) => ({
    getFeedback: build.query({
        query: () => `/feedbacks`,
        transformResponse: (response) => response.data,
        providesTags: ["feedbacks"],
    }),

  }),
});

export const {
  useGetFeedbackQuery,
} = FeedbackApi;
